export default {
    path: 'block',
    component: () => import('../Block.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Block',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Block',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Block',
            component: () => import('../cu/CU.vue'),
        },
    ]
};